<template>
   <div :class="col">
      <div class="mb-0 position-relative sa-field">
         <!-- Label above the box (main.js formStyle 'icons' and 'plain') -->
         <label v-if="label && !floating" :for="inputId" class="form-label">{{ label }}</label>

         <div :class="wrapClass" @focusin="focused = true" @focusout="focused = false">
            <!-- Icon in front (formStyle 'icons' only) -->
            <span v-if="showIcon" class="input-group-text align-items-start pt-2"><i :class="icon"></i></span>

            <textarea
               v-bind="$attrs"
               :id="inputId"
               :rows="rows"
               :value="modelValue"
               :placeholder="floating ? ' ' : placeholder"
               @input="$emit('update:modelValue', $event.target.value)"
               class="form-control custom-tooltip-input"
            ></textarea>

            <!-- Floating label: inside the box at the top, moves up onto the border (formStyle 'floating') -->
            <label v-if="floating" :for="inputId" class="sa-float-label">{{ label }}</label>
         </div>

         <!-- Grey note under the box, and the letters used when maxlength is set -->
         <div v-if="hint || maxLength" class="d-flex justify-content-between gap-2">
            <small class="text-muted">{{ hint }}</small>
            <small v-if="maxLength" class="text-muted text-nowrap">{{ length }} / {{ maxLength }}</small>
         </div>

         <!-- Above the box: on focus, and in red while the field is invalid -->
         <div v-if="tooltip" class="custom-tooltip">{{ tooltip }}<span class="tooltip-arrow"></span></div>
      </div>
   </div>
</template>

<script>
// Several lines of text: notes, address, description ...
//   <TextareaField v-model="formInputs.notes" col="col-12" label="Notes" icon="fa fa-sticky-note"
//                  rows="3" maxlength="500" tooltip="Anything we should know" />
// Looks follow main.js formStyle. required, minlength, maxlength ... go to the <textarea>
// (maxlength also shows a "120 / 500" counter under the box).
let nextId = 0;

export default {
   name: "TextareaField",
   inheritAttrs: false,
   props: {
      modelValue: { default: "" },
      label: { type: String, default: "" },
      icon: { type: String, default: "" },
      placeholder: { type: String, default: "" },
      tooltip: { type: String, default: "" },
      hint: { type: String, default: "" },
      col: { type: String, default: "col-12" },
      rows: { type: [String, Number], default: 3 },
      id: { type: String, default: "" },
   },
   emits: ["update:modelValue"],
   data() {
      return { autoId: "textarea-field-" + ++nextId, focused: false };
   },
   computed: {
      inputId() {
         return this.id || this.autoId;
      },
      formStyle() {
         return this.$formStyle || "icons";
      },
      floating() {
         return this.formStyle === "floating" && !!this.label;
      },
      showIcon() {
         return this.formStyle === "icons" && !!this.icon;
      },
      maxLength() {
         return parseInt(this.$attrs.maxlength, 10) || 0;
      },
      length() {
         return String(this.modelValue ?? "").length;
      },
      wrapClass() {
         if (this.showIcon) return "input-group";
         if (this.floating) {
            return {
               "sa-float": true,
               "sa-float-textarea": true,
               "is-up": this.focused || String(this.modelValue ?? "") !== "",
               "is-focused": this.focused,
            };
         }
         return "";
      },
   },
};
</script>